'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvPlaylistAddCheck = function AvPlaylistAddCheck(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z' })
  );
};
AvPlaylistAddCheck = (0, _pure2.default)(AvPlaylistAddCheck);
AvPlaylistAddCheck.displayName = 'AvPlaylistAddCheck';
AvPlaylistAddCheck.muiName = 'SvgIcon';

exports.default = AvPlaylistAddCheck;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/av/playlist-add-check.js
// module id = 2006
// module chunks = 0